module.exports = __webpack_public_path__ + "components/about-header/static/header--small-b98738d082baad57677eef1beead3518.jpg";